export default from './FooterList';



// WEBPACK FOOTER //
// ./src/components/FooterList/index.js